import { defineMessages } from 'react-intl';

export const scope = 'app.components.Communication.AudienceSelector';

export const messages = defineMessages({
  summaryEveryone: {
    id: `${scope}.summaryEveryone`,
    defaultMessage: 'This message will go to everyone in this assessment.'
  },
  summarySelection: {
    id: `${scope}.summarySelection`,
    defaultMessage: 'Sending to: {parts}'
  },
  summaryRecipients: {
    id: `${scope}.summaryRecipients`,
    defaultMessage: '{countDisplay} {athleteWord} {contactWord} will receive {notificationWord}'
  }
});
